<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <layout titlePage="Convites">
    <div class="columns columns--full is-vcentered save-the-date-layout">
      <div class="column">
        <div class="container has-text-centered">
          <p class="save-the-date-layout__description">
            Crie um convite, um pré-convite ou um comunicado para o seu
            casamento e envie aos seus<br />convidados para que eles fiquem
            informados sobre o seu grande dia!
          </p>
          <p class="save-the-date-layout__title">
            <b>Escolha o que deseja criar</b>
          </p>
          <cardsOfLayouts class="general__cards" :arrayLayouts="layouts" />
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import layout from '@/layouts/Default.vue'
import cardsOfLayouts from '@/components/Invites/BaseCardLayout.vue'

import layoutInviteImg from '@/assets/img/invites/modelo-convite.jpg'
import layoutSimpleImg from '@/assets/img/invites/modelo-simples.jpg'
import layoutCommunicationImg from '@/assets/img/invites/modelo-comunicado.jpg'

import Invites from '@/lib/api/Invites'

export default {
  computed: {
    logonToken() {
      return this.$store.state.app.logonToken
    },

    infosWedding: {
      get() {
        return this.$store.state.invites.weddingInfos
      },
      set(payload) {
        this.$store.dispatch('setWeddingInfo', payload)
      },
    },
  },

  components: {
    layout,
    cardsOfLayouts,
  },

  watch: {
    logonToken(payload) {
      this.loading = true
      if (
        payload &&
        payload.token &&
        payload.token_payload.wed_id &&
        !this.started
      ) {
        this.getData(payload)
      }
    },
  },

  data() {
    return {
      layouts: [
        {
          name: 'Convite oficial',
          title: 'oficial',
          img: layoutInviteImg,
        },
        {
          name: 'Save the Date',
          title: 'save-the-date',
          img: layoutSimpleImg,
        },
        {
          name: 'Comunicado com texto livre',
          title: 'comunicado',
          img: layoutCommunicationImg,
        },
      ],

      started: false,
    }
  },

  mounted() {
    this.loading = true
    if (
      this.logonToken &&
      this.logonToken.token &&
      this.logonToken.token_payload.wed_id &&
      !this.started
    ) {
      this.getData(this.logonToken)
    }
  },

  methods: {
    async getData(token) {
      this.started = true
      const InviteData = new Invites(token)
      const response = await InviteData.getSaveTheDateInfo(
        token.token_payload.wed_id
      )
      const mySiteInfo = response.data
      if (mySiteInfo) this.infosWedding = mySiteInfo
    },
  },

  metaInfo: {
    title: 'Save the Date',
  },
}
</script>

<style lang="scss">
.layout::before {
  content: none;
}
.save-the-date-layout {
  max-width: 1000px;
  margin: 0 auto !important;
  padding-top: 50px;
  padding-bottom: 40px;

  &__description {
    line-height: 32px;
    color: #6e7983;
    margin-bottom: 56px;
  }

  &__title {
    padding-top: 20px;
    font-family: Lato;
    font-size: 20px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1;
    letter-spacing: normal;
    text-align: center;
    color: #6e7983;
    margin-bottom: 64px;
  }
}

.general__cards {
  .cards {
    &__card {
      &__item {
        &--img {
          img {
            height: 300px;
            width: auto;
            object-fit: contain;
          }
        }
      }
    }
  }
}
</style>
